import { FC } from "react";
import { useTranslation } from "react-i18next";
import useEvent from "react-use-event-hook";

import { useModalConfirm } from "@ryde/redux";
import { ConfirmResult } from "@ryde/shared";

import { ColorIconButton } from "../../../controls";
import { CsvCellTemplate } from "../../templates-table";
import { IStationHubItem } from "./table-station-hub.models";

interface IStationHUbItemDisplayProps {
  item: IStationHubItem;
  disabledEdit?: boolean;
  disabledRemove?: boolean;
  onRemove: () => void;
  onEditClick: () => void;
}

export const StationHubItemDisplay: FC<IStationHUbItemDisplayProps> = ({
  item,
  disabledEdit,
  disabledRemove,
  onRemove,
  onEditClick,
}) => {
  const { t } = useTranslation();
  const { confirmDialogResult } = useModalConfirm();
  const message = t(`general.ITEM_ARCHIVE_MESSAGE`);

  const onArchiveClickEvent = useEvent(async (): Promise<void> => {
    const confirmationResult = await confirmDialogResult({
      title: t("general.CONFIRM"),
      message,
    });

    if (confirmationResult === ConfirmResult.OK) {
      onRemove();
    }
  });

  return (
    <div className="stationHub-item display-mode">
      <div className="stationHub-item__data">
        {Boolean(item?.hubId) && (
          <div className="stationHub-item__data--row">
            <label>{t("station.formLabel.hubStationId")}:</label>
            <CsvCellTemplate
              name={"hubId"}
              customClassName="stationHub-cell"
              value={[item.hubId]}
              formAttributes={{ dropItemsSource: "station" }}
            />
          </div>
        )}
        {Boolean(item?.destinationStationId) && (
          <div className="stationHub-item__data--row">
            <label>{t("station.formLabel.destinationStationId")}:</label>
            <CsvCellTemplate
              name={"destinationStationId"}
              customClassName="stationHub-cell"
              value={[item.destinationStationId]}
              formAttributes={{ dropItemsSource: "station" }}
            />
          </div>
        )}
        {Boolean(item?.direction) && (
          <div className="stationHub-item__data--row">
            <label>{t("general.DIRECTION")}:</label>
            <span className="stationHub-cell">
              {t(`selectListLabel.Dir${item.direction}`)}
            </span>
          </div>
        )}
      </div>
      <div className="stationHub-item__buttons">
        {!disabledEdit && (
          <ColorIconButton
            iconType="EDIT"
            edge="end"
            aria-label="edit"
            className="edit-button"
            onClick={onEditClick}
          />
        )}

        {!disabledRemove && (
          <ColorIconButton
            iconType="DELETE"
            edge="end"
            aria-label="delete"
            onClick={() => onArchiveClickEvent()}
          />
        )}
      </div>
    </div>
  );
};
